"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _index = _interopRequireDefault(require("./index"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } //
//
//
//
//
//
//
var _default2 = exports.default = {
  name: 'LineBarChart',
  components: {
    echartsNew: _index.default
  },
  props: {
    // 图表标题
    title: {
      type: String,
      default: ''
    },
    // 颜色列表
    colorList: {
      type: Array,
      default: function _default() {
        return ['#1890ff', '#fa8c16', '#e6a23c', '#52c41a', '#A277FF'];
      }
    },
    // 图表高度
    height: {
      type: String,
      default: '400px'
    },
    // 图表宽度
    width: {
      type: String,
      default: '100%'
    },
    // 图例名称列表
    legendNameList: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    // 图例图标列表 ['circle', 'rect'] (圆形，矩形)
    legendIconList: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    // 图例位置配置
    legend: {
      type: Object,
      default: function _default() {
        return {
          orient: 'horizontal',
          top: 'bottom',
          left: 'center'
        };
      }
    },
    // x轴类型
    xType: {
      type: String,
      default: 'category'
    },
    // x轴数据
    xData: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    // x轴配置
    xAxis: {
      type: Object,
      default: function _default() {
        return {
          type: 'category',
          boundaryGap: true,
          axisLine: {
            lineStyle: {
              color: '#E5E8EF'
            }
          },
          axisLabel: {
            color: '#666'
          },
          axisTick: {
            alignWithLabel: true
          }
        };
      }
    },
    // 图表类型 ['line', 'bar']
    ySeriesType: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    // 折线是否平滑 [true, false]
    isSmoothList: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    // 图表数据 {'标签名1': [数据1], '标签名2': [数据2]}
    ySeriesData: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    // y轴名称 ['名称1', '名称2']
    yAxisName: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    // y轴数据类型 ['value', 'category']
    yAxisType: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    // y轴位置 ['left', 'right']
    yAxisPosition: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    // 图表数据对应y轴的索引 [0, 1]
    yAxisIndex: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    // y轴配置
    yAxis: {
      type: Array,
      default: function _default() {
        var _this = this;
        var yAxisOpt = this.yAxisName.map(function (item, index) {
          return {
            type: _this.yAxisType[index] || 'value',
            name: item || '值',
            position: _this.yAxisPosition[index] || 'left',
            min: 0,
            axisLine: {
              show: false
            },
            splitLine: {
              lineStyle: {
                color: '#F0F0F0'
              }
            },
            axisLabel: {
              color: '#666',
              margin: 30
            }
          };
        });
        return yAxisOpt;
      }
    }
  },
  computed: {
    // 图表样式
    chartStyles: function chartStyles() {
      return {
        width: this.width,
        height: this.height
      };
    },
    // 图表配置
    chartOption: function chartOption() {
      var _this2 = this;
      var legendData = [];
      var seriesOpt = this.legendNameList.map(function (item, index) {
        legendData.push({
          name: item,
          icon: _this2.legendIconList[index] || ''
        });
        return {
          name: item,
          type: _this2.ySeriesType[index],
          yAxisIndex: _this2.yAxisIndex[index] || 0,
          smooth: _this2.isSmoothList[index] || false,
          symbol: 'circle',
          symbolSize: '6',
          lineStyle: {
            width: 2
          },
          barMaxWidth: 20,
          data: _this2.ySeriesData[item]
        };
      });
      return {
        color: this.colorList,
        // 指针数据显示
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'none'
          }
        },
        // 图例
        legend: _objectSpread({
          data: legendData
        }, this.legend),
        // x轴配置
        xAxis: _objectSpread({
          data: this.xData
        }, this.xAxis),
        // y轴配置
        yAxis: this.yAxis,
        // 数据配置
        series: seriesOpt
      };
    }
  }
};